import React from 'react';
import PropTypes from 'prop-types';
import { CallupHead } from 'ThreeTerminal_mobile_dynamic';
import errorBoundary from '@ifeng/errorBoundary';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        keyword: PropTypes.array,
        subid: PropTypes.string,
        wxLaunch: PropTypes.object,
    };

    render() {
        const { content, keyword, subid, wxLaunch } = this.props;
        const subidVal = subid ? `&subid=${subid}` : '';
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
              };

        const headData = {
            isVideoShare: content.isVideoShare,
            pageInfo: {
                type: content.type === 'article' ? 'doc' : content.type,
                url: typeof window === 'object' ? location.href : '',
                id: content._id,
                downloads,
            },
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                ref: `ucms_${content.base62Id}`,
                kind: 'article',
                callupKind: 'share01',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                ref: `ucms_${content.base62Id}`,
                kind: 'article',
                callupKind: 'share01',
            },
            hotKeyword: keyword,
            wxLaunchType: wxLaunch.wxLaunchType,
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch,
        };

        return <CallupHead content={headData} />;
    }
}

export default errorBoundary(Header);
